import React, { useState } from "react";
import { DashboardHeader } from "../../sections/superadmin/DashboardHeader";
import { NavigationTabs } from "../../sections/superadmin/NavigationTabs";
import { Districts } from "../../sections/superadmin/Districts";
import { Schools } from "../../sections/superadmin/Schools";
import { Admins } from "../../sections/superadmin/Admins";
import { Teachers } from "../../sections/superadmin/Teachers";
import SuperAdminCurriculumConfig from "../../sections/superadmin/CurriculumConfig";

export type TabType =
  | "districts"
  | "schools"
  | "admins"
  | "teachers"
  | "curriculum-config"
  | "grade-weighting";

function SuperAdminDashboard() {
  const [activeTab, setActiveTab] = useState<TabType>("districts");

  return (
    <div>
      <DashboardHeader />

      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <NavigationTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === "districts" && <Districts />}
        {activeTab === "schools" && <Schools />}
        {activeTab === "admins" && <Admins />}
        {activeTab === "teachers" && <Teachers />}
        {activeTab === "curriculum-config" && <SuperAdminCurriculumConfig />}
      </main>
    </div>
  );
}

export default SuperAdminDashboard;
